var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChangelog = function SvgChangelog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#changelog_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "M5.5 15h30m-30 10h30m-22-20h14c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C35.5 8.8 35.5 10.2 35.5 13v14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C31.7 35 30.3 35 27.5 35h-14c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C5.5 31.2 5.5 29.8 5.5 27V13c0-2.8 0-4.2.545-5.27A5 5 0 0 1 8.23 5.545C9.3 5 10.7 5 13.5 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "changelog_svg__a",
    x1: 32.838,
    x2: -27.117,
    y1: 5.828,
    y2: 28.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgChangelog;